module.exports = __webpack_public_path__ + "img/ba.f02ca102.svg";